import { render } from "./LinkedInSigninButton.vue?vue&type=template&id=fee8dc1a&scoped=true&ts=true"
import script from "./LinkedInSigninButton.ts?vue&type=script&lang=ts&external"
export * from "./LinkedInSigninButton.ts?vue&type=script&lang=ts&external"

import "./LinkedInSigninButton.scss?vue&type=style&index=0&id=fee8dc1a&lang=scss&scoped=true&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fee8dc1a"]])

export default __exports__